<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.monthlyReportList.push"
    :query-list="queryList"
    :is-show-store-select="isAdministrator"
    :is-store-select-clearable="true"
    :is-show-month-range-picker="true"
    :picker-options="pickerOptions"
    :show-summary="true"
  >

    <el-table-column type="expand" v-if="!is2k">
      <template v-slot="{ row }">
        <el-form label-position="left" inline class="table-expand">
          <el-form-item label="月总结 ID">{{ row.id }}</el-form-item>

          <el-form-item label="月总结日期">{{ row.report_date | timeToYm }}</el-form-item>

          <el-form-item label="操作者">
            <v-avatar-nickname
              :value="row.administrator_avatar"
              :nickname="row.administrator_nickname"
              :is-center="true"
              :nickname-overflow="true"
              :avatar-size="50"
            />
          </el-form-item>

          <el-form-item label="添加时间">{{ row.add_time | timeToYmdHi }}</el-form-item>
        </el-form>
      </template>
    </el-table-column>

    <el-table-column v-if="is2k" width="70px" label="ID" prop="id"/>

    <v-column-time field="report_date" time-format="timeToYm" value="日期"/>
    <v-column-time v-if="is2k" sortable=""/>
    <v-column-admin v-if="is2k"/>

    <el-table-column v-if="isAdministrator" label="门店" prop="store_name"/>

    <el-table-column width="140px" label="有赞支付" prop="you_zan_income" type="money">
      <template v-slot="{ row }">
        {{ row.you_zan_income | toYuan }}
      </template>
    </el-table-column>

    <el-table-column
      width="120px"
      label="收入"
      sortable="custom"
      :sort-orders="['ascending', 'descending']"
      prop="all_income"
      type="money"
    >
      <template v-slot="{ row }">{{ row.all_income | toYuan }}</template>
    </el-table-column>

    <el-table-column width="120px" label="支出" prop="expenditure" type="money">
      <template v-slot="{ row }">{{ row.expenditure | toYuan }}</template>
    </el-table-column>

    <el-table-column
      width="120px"
      label="盈利"
      sortable="custom"
      :sort-orders="['ascending', 'descending']"
      prop="profit"
      type="money"
    >
      <template v-slot="{ row }">{{ row.profit | toYuan }}</template>
    </el-table-column>

    <el-table-column width="120px" label="课消" prop="course_consumption" type="money">
      <template v-slot="{ row }">{{ row.course_consumption | toYuan }}</template>
    </el-table-column>

    <el-table-column width="70px" label="大课">
      <template v-slot="{ row }">{{ row.group_course_count | toYuan }}</template>
    </el-table-column>
    <el-table-column width="70px" label="小课">
      <template v-slot="{ row }">{{ row.private_course_count | toYuan }}</template>
    </el-table-column>
    <el-table-column width="80" label="大课人次">
      <template v-slot="{ row }">{{ row.total_attendance | toYuan }}</template>
    </el-table-column>

    <el-table-column width="80px" label="平均人数" prop="average_attendance" type="average">
      <template v-slot="{ row }">{{ row.average_attendance | toYuan }}</template>
    </el-table-column>

    <el-table-column label="发布状态" width="150" align="center" prop="updateState">
      <template v-slot="{ row }">
        <el-tag v-if="row.is_draft" type="info">草稿</el-tag>
        <el-tag v-else type="success">已发布</el-tag>
      </template>
    </el-table-column>

    <el-table-column label="操作" width="250px">
      <template v-slot="{ row }">
        <v-list-button
          name="查看"
          icon="browse"
          :to="RouteConfig.monthlyReportDetail.to(row.id)"
        />

        <v-list-button :to="RouteConfig.monthlyReportEdit.to(row.id)"/>

        <v-popover>
          <v-popover-item
            icon="bin"
            name="删除总结"
            @click="handleDelete(row)"
            :is-loading="isDeleting[row.id]"
            message="确认要删除该月总结吗？"
          />
        </v-popover>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加者</span>
              <v-avatar-nickname
                :value="v.administrator_avatar"
                :nickname="v.administrator_nickname"
                :is-center="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>月总结 ID</span>
              <span>{{ v.id }}</span>
            </div>

            <div class="list-item-detail">
              <span>月总结日期</span>
              <span>{{ v.report_date | timeToYmd }}</span>
            </div>

            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div v-if="isAdministrator" class="list-item-detail">
              <span>所属门店</span>
              <span>{{ v.store_name || '' }}</span>
            </div>

            <div class="list-item-detail">
              <span>有赞收入</span>
              <span>{{ v.you_zan_income | toYuan }} 元</span>
            </div>

            <div class="list-item-detail">
              <span>总收入</span>
              <span>{{ v.all_income | toYuan }} 元</span>
            </div>

            <div class="list-item-detail">
              <span>总支出</span>
              <span>{{ v.expenditure | toYuan }} 元</span>
            </div>

            <div class="list-item-detail">
              <span>盈利</span>
              <span>{{ v.profit | toYuan }} 元</span>
            </div>

            <div class="list-item-detail">
              <span>课消</span>
              <span>{{ v.course_consumption | toYuan }} 元</span>
            </div>

            <div class="list-item-detail">
              <span>大课数量</span>
              <span>{{ v.group_course_count | toYuan }} 小时</span>
            </div>

            <div class="list-item-detail">
              <span>小课数量</span>
              <span>{{ v.private_course_count | toYuan }} 小时</span>
            </div>

            <div class="list-item-detail">
              <span>大课总人数</span>
              <span>{{ v.total_attendance | toYuan }} 人</span>
            </div>

            <div class="list-item-detail">
              <span>平均人数</span>
              <span>{{ v.average_attendance | toYuan }} 人</span>
            </div>

            <div class="list-item-detail">
              <span>发布状态</span>
              <el-tag v-if="v.is_draft" type="info">草稿</el-tag>
              <el-tag v-else type="success">已发布</el-tag>
            </div>

            <div class="list-item-button">
              <v-list-button
                name="查看"
                icon="browse"
                :to="RouteConfig.monthlyReportDetail.to(v.id)"
              />

              <v-list-button :to="RouteConfig.monthlyReportEdit.to(v.id)"/>

              <v-popover>
                <v-popover-item
                  icon="bin"
                  name="删除总结"
                  @click="handleDelete(v)"
                  :is-loading="isDeleting[v.id]"
                  message="确认要删除该月总结吗？"
                />
              </v-popover>
            </div>
          </div>

          <div class="list-item list-count-box primary-background-light">
            <div class="list-item-detail">
              <strong>本页合计</strong>
            </div>
            <div class="list-item-detail">
              <span>有赞支付</span>
              <span class="income-count">{{ youZanIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>收入</span>
              <span class="income-count">{{ allIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>支出</span>
              <span class="pay-count">{{ expenditure | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>盈利</span>
              <span :class="profit >= 0 ? 'income-count' : 'pay-count'">{{ profit | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>课消</span>
              <span>{{ courseConsumption | toYuan }} 元</span>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
  import RouteConfig from '@/router/config';
  import { mapGetters } from 'vuex';
  import { index, destroy } from '@/api/monthly-report';
  import { checkYmdIsBetweenSetUpAndToday } from '@/utils/validate';
  import { getLegalQueryList, pickerOptionsBetweenSystemStartAndToday } from '@/utils/formats';
  import { plus } from '@/filters';

  export default {
    name: RouteConfig.monthlyReportList.name,
    data: () => ({
      RouteConfig,
      isLoading: false,
      isDeleting: {},
      count: 0,
      list: [],
      timeLimit: [],
      reports: [],
      stores: [],
      youZanIncome: 0,
      allIncome: 0,
      expenditure: 0,
      profit: 0,
      courseConsumption: 0,
      queryList: {
        store_id: '',
        start_date: '',
        end_date: '',
        is_asc: 0,
        page: 1,
        size: 10,
      },
      pickerOptionsBetweenSystemStartAndToday,
      pickerOptions: {
        disabledDate: time => time.getTime() >= Date.now(),
        shortcuts: [
          {
            text: '上月',
            onClick(picker) {
              let currentDate = new Date();
              let lastMonth = currentDate.getMonth() - 1;
              let currentYear = currentDate.getFullYear();
              let startDate = new Date(currentYear, lastMonth,1);
              let endDate = new Date(currentYear, lastMonth, 31);
              picker.$emit('pick', [startDate, endDate]);
            },
          },
          {
            text: '去年',
            onClick(picker) {
              let currentDate = new Date();
              let currentYear = currentDate.getFullYear() - 1;
              let startDate = new Date(currentYear, 0,1);
              let endDate = new Date(currentYear, 11,31);
              picker.$emit('pick', [startDate, endDate]);
            },
          },
          {
            text: '今年',
            onClick(picker) {
              let currentDate = new Date();
              let currentMonth = currentDate.getMonth();
              let currentYear = currentDate.getFullYear();
              let startDate = new Date(currentYear, 0,1);
              let endDate = new Date(currentYear, currentMonth,1);
              picker.$emit('pick', [startDate, endDate]);
            },
          },
        ],
      },
    }),
    watch: {
      '$route'(to) {
        this.load(to);
      },
    },
    computed: {
      ...mapGetters([
        'isMobile',
        'isAdministrator',
        'isManager',
        'isReceptionist',
        'userStoreId',
        'is2k',
      ]),
    },
    methods: {
      refresh() {
        RouteConfig.monthlyReportList.push(this.queryList);
      },
      handleStoreChange() {
        this.queryList.page = 1;
        this.refresh();
      },
      handleTimeLimitChange(times) {
        if (!times || !times.length) times = ['', ''];

        this.timeLimit = times;
        const [start_date, end_date] = times;

        Object.assign(this.queryList, {
          start_date,
          end_date,
          page: 1,
        });
        this.refresh();
      },
      handlePageChange({ page, size }) {
        this.queryList.page = page;
        this.queryList.size = size;
        this.refresh();
      },
      async load(route = this.$route, next) {
        const { queryList } = this;
        const { query } = route;
        getLegalQueryList(queryList, query);

        const startDateIsValid = checkYmdIsBetweenSetUpAndToday(query.start_date);
        const endDateIsValid = checkYmdIsBetweenSetUpAndToday(query.end_date);

        if (startDateIsValid && endDateIsValid) {
          queryList.start_date = query.start_date;
          queryList.end_date = query.end_date;
        } else {
          queryList.start_date = '';
          queryList.end_date = '';
        }

        this.isLoading = true;
        const { isError, data } = await index(this.queryList);
        this.isLoading = false;

        if (next) next();
        if (isError) return;

        this.count = data.count;
        this.list = data.list;

        const list = data.list;
        const length = list.length;

        let youZanIncome = 0;
        let allIncome = 0;
        let expenditure = 0;
        let profit = 0;
        let courseConsumption = 0;

        for (let i = 0; i < length; i++) {
          youZanIncome = plus(youZanIncome, list[i].you_zan_income);
          allIncome = plus(allIncome, list[i].all_income);
          expenditure = plus(expenditure, list[i].expenditure);
          profit = plus(profit, list[i].profit);
          courseConsumption = plus(courseConsumption, list[i].course_consumption);
        }

        Object.assign(this, {
          youZanIncome,
          allIncome,
          expenditure,
          profit,
          courseConsumption,
        });
      },
      async handleDelete({ id }) {
        this.$set(this.isDeleting, id, true);
        const { isError } = await destroy(id);
        this.$set(this.isDeleting, id, false);
        if (isError) return;

        this.load();
      },
    },
    beforeRouteUpdate(to, from, next) {
      this.load(to, next);
    },
    beforeMount() {
      this.load();
    },
  };
</script>
